import { createSelector } from "reselect";
import { createDBServiceSlice } from "./db-service-reducers";
import { FeedMetadata } from "./api-interfaces";

export const {
    slice: FeedMetadataSlice,
    dbThunks: _FeedMetadataThunks,
    selectByQuery: _feedMetadataSelectByQuery,
    selectOneObjectByQuery: _feedMetadataSelectOneObjectByQuery,
    selectOneFieldByQuery: _feedMetadataSelectOneFieldByQuery,
    selectors: _feedMetadataSelectors,
    selectByQueryOnlyLength: _feedMetadataSelectByQueryOnlyLength,
    selectByQueryOnlyMaxMin: _feedMetadataSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<FeedMetadata>({
    service: "feed-metadata",
    initialState: { ids: [], entities: {}, itemsLoaded: false, itemsLoading: false },
    getReducerState: (state) => state.DBFeedMetadataReducer,
});

export const DBFeedMetadataReducer = FeedMetadataSlice.reducer;
export const FeedMetadataReducerActions = FeedMetadataSlice.actions;
export type feedMetadataReducerActions = keyof typeof FeedMetadataReducerActions;
export const DBFeedMetadataThunks = _FeedMetadataThunks;
export const feedMetadataSelectors = _feedMetadataSelectors;
export const feedMetadataSelectByQuery = _feedMetadataSelectByQuery;
export const feedMetadataSelectByQueryOnlyLength = _feedMetadataSelectByQueryOnlyLength;
export const feedMetadataSelectByQueryOnlyMaxMin = _feedMetadataSelectByQueryOnlyMaxMin;
export const feedMetadataSelectOneObjectByQuery = _feedMetadataSelectOneObjectByQuery;
export const feedMetadataSelectOneFieldByQuery = _feedMetadataSelectOneFieldByQuery;

export interface ConnectionSegment {
    feedTag: string;
    channelTag: string;
    connectedAt: Date;
    disconnectedAt?: Date;
}

// selector to select the feed metadata by id
export const selectFeedMetadataMap = createSelector(
    feedMetadataSelectors.selectAll,
    (feedMetadataList: FeedMetadata[]) => {
        const feedMetadataMap = new Map<string, FeedMetadata>();
        feedMetadataList.forEach((metadata) => {
            feedMetadataMap.set(metadata.offerId ?? '', metadata);
        });
        return feedMetadataMap;
    }
);